import { render, staticRenderFns } from "./TextInputDate.vue?vue&type=template&id=a80057b4&lang=html"
import script from "./TextInputDate.vue?vue&type=script&lang=js"
export * from "./TextInputDate.vue?vue&type=script&lang=js"
import style0 from "./TextInputDate.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports